import { useEffect, useState } from 'react';
import Breakpoints from '@/common/constants/breakpoints';
import { debounce } from '@/helpers/debounce';

const useVisibility = (): boolean => {
  const [isVisible, setVisibility] = useState<boolean>(false);

  const checkVisibility = (): void => {
    const viewportWidth = window.innerWidth;

    if (viewportWidth >= Breakpoints.md) {
      setVisibility(false);

      return;
    }

    const viewportHeight = window.innerHeight;

    const contentContainer = document.getElementById('article-content');
    const contentContainerTop = contentContainer?.getBoundingClientRect()?.top || 0;
    if (contentContainerTop > viewportHeight) {
      setVisibility(false);

      return;
    }

    const sideBarCard = document.getElementById('sidebar-card');
    const sideBarCardTop = sideBarCard?.getBoundingClientRect()?.top || 0;

    setVisibility(sideBarCardTop > viewportHeight);
  };

  const handleScroll = debounce(() => {
    checkVisibility();
  }, 100);

  useEffect((): () => void => {
    setTimeout(checkVisibility, 0);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return (): void => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return isVisible;
};

export default useVisibility;
